import { ReactComponent as Steps } from "@icons/steps.svg";
import { TrackerProgressCard } from "../../../components/Trackers/TrackerProgressCard";
import { TrackerThresholdPercentages } from "core/state/Trackers/TrackerThresholdPercentages";
import { TrackerType } from "core/state/Trackers/TrackerType";
import { t } from "i18next";
import { useTrackerContext } from "core/state/TrackerContext/TrackerContext";

export const StepsTrackerProgressCard = () => {
  const { getCurrentTrackerValue, getGoal } = useTrackerContext();

  const current = getCurrentTrackerValue(TrackerType.Steps);
  let goal = getGoal(TrackerType.Steps);
  const percent = current.percentageOf(goal, 0);

  function getProgressMessage(percentage: number): string {
    switch (true) {
      case percentage >= 100:
        return t(`wellbeing.trackers.progress.complete`);
      case percentage > TrackerThresholdPercentages.High:
        return t("wellbeing.trackers.steps.progress.high", { current, percent });
      case percentage >= TrackerThresholdPercentages.Medium:
        return t("wellbeing.trackers.steps.progress.medium", { current, percent });
      default:
        return t("wellbeing.trackers.steps.progress.low", { current, percent });
    }
  }

  return (
    <TrackerProgressCard
      trackerType={TrackerType.Steps}
      percentage={percent}
      heading={t("wellbeing.trackers.steps.progress.heading")}
      goalHeading={t("wellbeing.trackers.steps.goal.heading")}
      goalDescription={t("wellbeing.trackers.steps.goal.description")}
      goalIncrement={1000}
      goalUnit={t("wellbeing.trackers.steps.goal.unit")}
      progressMessage={getProgressMessage(percent)}
      Icon={Steps}
    />
  );
};
